import { OnlineGameState } from "../types/game";
import { OnlineMatchState } from "../types/match";
import { BaseRequest, HitRequest, PrivateMatchRequest } from "../types/online";
import { ROUTE } from "../types/routes";

export async function joinCricketMatch() {
  const onlineMatch = await fetch(ROUTE.JOIN_CRICKET.url, {
    method: ROUTE.JOIN_CRICKET.method,
  });
  const body: OnlineMatchState = await onlineMatch.json();
  // @ts-ignore
  if (body.error) {
    // @ts-ignore
    throw new Error(body.error);
  }
  return body;
}

export async function join301Match() {
  const onlineMatch = await fetch(ROUTE.JOIN_301.url, {
    method: ROUTE.JOIN_301.method,
  });
  const body: OnlineMatchState = await onlineMatch.json();
  // @ts-ignore
  if (body.error) {
    // @ts-ignore
    throw new Error(body.error);
  }
  return body;
}

export async function join501Match(): Promise<OnlineMatchState> {
  const onlineMatch = await fetch(ROUTE.JOIN_501.url, {
    method: ROUTE.JOIN_501.method,
  });
  const body: OnlineMatchState = await onlineMatch.json();
  // @ts-ignore
  if (body.error) {
    // @ts-ignore
    throw new Error(body.error);
  }
  return body;
}

export async function joinPrivateMatch(roomCode: string) {
  const onlineMatch = await fetch(ROUTE.JOIN_PRIVATE.url(roomCode), {
    method: ROUTE.JOIN_PRIVATE.method,
  });
  const body: OnlineMatchState = await onlineMatch.json();
  // @ts-ignore
  if (body.error) {
    // @ts-ignore
    throw new Error(body.error);
  }
  return body;

}


export async function createPrivateMatch(gameOptions: PrivateMatchRequest) {
  const postBody: string = JSON.stringify(gameOptions);
  const onlineMatch = await fetch(ROUTE.CREATE_PRIVATE.url, {
    method: ROUTE.CREATE_PRIVATE.method,
    body: postBody
  });
  const body: OnlineMatchState = await onlineMatch.json();
  // @ts-ignore
  if (body.error) {
    // @ts-ignore
    throw new Error(body.error);
  }
  return body;
}



export async function cricketHit(hit: HitRequest) {
  const postBody: string = JSON.stringify(hit);
  const onlineMatch = await fetch(ROUTE.CRICKET_HIT.url, {
    method: ROUTE.CRICKET_HIT.method,
    body: postBody
  });
  const body: OnlineMatchState = await onlineMatch.json();
  // @ts-ignore
  if (body.error) {
    // @ts-ignore
    throw new Error(body.error);
  }
  return body;
}

export async function x01Hit(hit: HitRequest) {
  const postBody: string = JSON.stringify(hit);
  const onlineMatch = await fetch(ROUTE.X01_HIT.url, {
    method: ROUTE.X01_HIT.method,
    body: postBody
  });
  const body: OnlineMatchState = await onlineMatch.json();
  // @ts-ignore
  if (body.error) {
    // @ts-ignore
    throw new Error(body.error);
  }
  return body;
}

export async function getMatchState(id: string) {
  const onlineMatch = await fetch(ROUTE.GET_MATCH_STATE.url(id), {
    method: ROUTE.GET_MATCH_STATE.method,
  });
  const body: OnlineMatchState = await onlineMatch.json();
  // @ts-ignore
  if (body.error) {
    // @ts-ignore
    throw new Error(body.error);
  }
  return body;
}

export async function getGameState(id: string) {
  const onlineMatch = await fetch(ROUTE.GET_GAME_STATE.url(id), {
    method: ROUTE.GET_GAME_STATE.method,
  });
  const body: OnlineMatchState = await onlineMatch.json();
  return { players: body.players, gameState: body.gameState };
}

export async function endLegRequest(req: BaseRequest) {
  const postBody: string = JSON.stringify(req);
  const onlineMatch = await fetch(ROUTE.END_LEG.url, {
    method: ROUTE.END_LEG.method,
    body: postBody
  });
  const body: OnlineMatchState = await onlineMatch.json();
  // @ts-ignore
  if (body.error) {
    // @ts-ignore
    throw new Error(body.error);
  }
  return body;
}


export async function undoRequest(req: BaseRequest) {
  const postBody: string = JSON.stringify(req);
  const onlineMatch = await fetch(ROUTE.UNDO_REQUEST.url, {
    method: ROUTE.UNDO_REQUEST.method,
    body: postBody
  });
  const body: OnlineGameState = await onlineMatch.json();
  // @ts-ignore
  if (body.error) {
    // @ts-ignore
    throw new Error(body.error);
  }
  return body;
}

export async function denyUndo(req: BaseRequest) {
  const postBody: string = JSON.stringify(req);
  const onlineMatch = await fetch(ROUTE.DENY_UNDO.url, {
    method: ROUTE.DENY_UNDO.method,
    body: postBody
  });
  const body: OnlineGameState = await onlineMatch.json();
  // @ts-ignore
  if (body.error) {
    // @ts-ignore
    throw new Error(body.error);
  }
  return body;
}


export async function continueGameRequest(request: BaseRequest) {
  const postBody: string = JSON.stringify(request);
  const onlineMatch = await fetch(ROUTE.CONTINUE_REQUEST.url, {
    method: ROUTE.CONTINUE_REQUEST.method,
    body: postBody
  });
  const body: OnlineMatchState = await onlineMatch.json();
  // @ts-ignore
  if (body.error) {
    // @ts-ignore
    throw new Error(body.error);
  }
  return body;
}

export async function restartGameRequest(request: BaseRequest) {
  const postBody: string = JSON.stringify(request);
  const onlineMatch = await fetch(ROUTE.RESTART_REQUEST.url, {
    method: ROUTE.RESTART_REQUEST.method,
    body: postBody
  });
  const body: OnlineMatchState = await onlineMatch.json();
  // @ts-ignore
  if (body.error) {
    // @ts-ignore
    throw new Error(body.error);
  }
  return body;
}

export async function onPlayerLeave(request: BaseRequest) {
  const postBody: string = JSON.stringify(request);
  await fetch(ROUTE.PLAYER_LEAVE.url, {
    method: ROUTE.PLAYER_LEAVE.method,
    body: postBody
  });
  return;
}